import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { TeamConfirmRoleDialogComponent } from './team-confirm-role-dialog.component';

@NgModule({
  declarations: [TeamConfirmRoleDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ReactiveFormsModule],
  exports: [TeamConfirmRoleDialogComponent],
  entryComponents: [TeamConfirmRoleDialogComponent],
})
export class TeamConfirmRoleDialogModule {}
